var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLPsWIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2172 10.9828L3.87188 0.609375L17.0344 8.16562L14.2172 10.9828ZM1.17188 0C0.562506 0.31875 0.154694 0.9 0.154694 1.65469V22.3406C0.154694 23.0953 0.562506 23.6766 1.17188 23.9953L13.2 11.9953L1.17188 0ZM21.1031 10.575L18.3422 8.97656L15.2625 12L18.3422 15.0234L21.1594 13.425C22.0031 12.7547 22.0031 11.2453 21.1031 10.575ZM3.87188 23.3906L17.0344 15.8344L14.2172 13.0172L3.87188 23.3906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPsWIcon);
export default __webpack_public_path__ + "static/media/l_ps_w_icon.d560457a4a5ad391f2820c2a3a5889ee.svg";
export { ForwardRef as ReactComponent };